import type { Position } from '@interfaces/base';
import type { CanvasCursor } from './cursor';

export enum HandleId {
  TopLeft = 'tl',
  TopMid = 'tm',
  TopRight = 'tr',
  MidLeft = 'ml',
  MidRight = 'mr',
  BottomLeft = 'bl',
  BottomMid = 'bm',
  BottomRight = 'br',
  // Circle edge handles
  Top = 't',
  Right = 'r',
  Bottom = 'b',
  Left = 'l',
  // Arrow handles
  Start = 'start',
  End = 'end',
}

export interface HandleInfo extends Position {
  id: HandleId;
  cursor: CanvasCursor;
}
